import BannerSlide from '../shared/BannerSlider/BannerSlide'
import FeaturedCard from '../shared/FeaturedCard/FeaturedCard'
import WhoWeAre from './WhoWeAre'
import TalkToSupportBanner from '../shared/TalkToSupport'
import UniveralBanner from '../shared/UniversalBanner'
import { StyleContentWrapper } from '../commons/ContentWrapper/style'
import Faq from '../shared/Faq'
import ContactUsBanner from '../shared/ContactusBanner'
import DownloadAppBanner from '../shared/DownloadAppBanner'
import Footer from '../Layout/Footer'
import HowItWorks from '../shared/HowItWorks'
import { useSeoData } from '../hook/useSeoData'
import { useFaqData } from '../hook/useFaqData'
import SeoHead from '../shared/SeoHead/SeoHead'
const AboutUs = () => {
  const seo = useSeoData('about-seo', 'aboutSeo')
  const faq = useFaqData('General')
  return (
    <>
      <SeoHead seo={seo} />
      <BannerSlide />
      <WhoWeAre />
      <FeaturedCard />
      <TalkToSupportBanner />
      <HowItWorks />
      <StyleContentWrapper stretch paddingRight="30" paddingLeft="30">
        <UniveralBanner />
      </StyleContentWrapper>
      <Faq faqData={faq} />
      <ContactUsBanner />
      <DownloadAppBanner />
      <Footer />
    </>
  )
}

export default AboutUs
